import { Reducer } from 'redux';
import _ from 'lodash';

import { ExperimentVariant } from 'actions/ExperimentActions';
import { consumer, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  variants: {
    [key: string]: ExperimentVariant;
  };
  configuration: {
    [key: string]: consumer.IExperimentConfiguration;
  };
}

const initialState: State = { variants: {}, configuration: {} };

const reducer: Reducer<State> = (state: State = initialState, action: BaseTockAction) => {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SET_EXPERIMENT_VARIANT: {
      const { experiments } = action.payload;
      const exps = _.keyBy(experiments, 'name');
      return {
        ...state,
        variants: {
          ...state.variants,
          ...exps,
        },
      };
    }
    // note, this probably doesn't work right now for overriding live experiments in prod, since the browser experiment variant will overwrite the extension variant.
    // But it's useful for local dev and staging, and we can fix the prod thing later, URL based overwrites still work for that case
    case AppConstants.CONFIG_FETCH_DONE: {
      const config = payloadToJSON<consumer.ConsumerConfig>(payload);
      const experiments = _.reduce(
        config.experiment,
        (experimentsAccum: Dictionary<ExperimentVariant>, experiment: consumer.IExperiment) => {
          const expName = experiment.name || undefined;
          if (expName) {
            experimentsAccum[expName] = {
              name: expName,
              variant: experiment.variant || 0,
              id: 'extension_override',
              numVariants: 2,
            };
          }
          return experimentsAccum;
        },
        {}
      );

      const experimentConfigs: Dictionary<consumer.IExperimentConfiguration> = _.keyBy(
        config.experimentConfiguration,
        'name'
      );

      return {
        ...state,
        variants: {
          ...state.variants,
          ...experiments,
        },
        configuration: {
          ...state.configuration,
          ...experimentConfigs,
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
